import splitVocabularyTerms from '@UI/Pages/AiAssignments/Shared/Sidebars/UsageSettingsSidebar/FormData/constraint/splitVocabularyTerms';

/** The minimal shape this constraint reads, generic over the FormData rather than importing it back. */
type VocabularyTermsShape = {
	readonly isVocabularyOverridden: boolean;
	readonly vocabularyBounds: { readonly maxTerms: number; readonly maxTermLength: number };
};

/**
 * Only runs when the switch is on: an inherited (non-overridden) field is never sent, so its raw text
 * — possibly stale from a previous edit — must not block submission (`guides/forms.md`, conditional
 * requiredness). Doubles the server's bounds (`@ArrayMaxSize(200)` / `@MaxLength(60, { each: true })`)
 * client-side.
 */
function isVocabularyTermsValid<T extends VocabularyTermsShape>(value: string, formData: T): boolean {
	if (!formData.isVocabularyOverridden) {
		return true;
	}

	const terms = splitVocabularyTerms(value);

	if (terms.length > formData.vocabularyBounds.maxTerms) {
		return false;
	}

	return terms.every((term) => term.length <= formData.vocabularyBounds.maxTermLength);
}

export default isVocabularyTermsValid;
